import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

// Import logger script
@Component({
  selector: 'app-root',
  // standalone: true,
  // imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'WiFleet-tracking-panel';

  constructor(private titleService: Title) { }
  ngOnInit(): void {
  }
}
